import {styled, useTheme} from "@mui/styles";
import {TreeItem, treeItemClasses} from "@mui/x-tree-view/TreeItem";
import React from "react";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Drop from "../DragDrop/Drop";
import {Tooltip} from "@mui/material";

const StyledTreeItemRoot = styled(TreeItem)(({theme}) => ({
    color: theme.palette.text.primary,
    [`& .${treeItemClasses.content}`]: {
        color: theme.palette.text.primary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '&.Mui-expanded': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
            color: 'var(--tree-view-color)',
        },
        [`& .${treeItemClasses.label}`]: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
    },
    [`& .${treeItemClasses.group}`]: {
        marginLeft: 0,
        [`& .${treeItemClasses.content}`]: {
            paddingLeft: theme.spacing(2),
        },
    },
}));

const StyledTreeItem = React.forwardRef(function StyledTreeItem(props, ref) {
    const theme = useTheme();
    const {
        bgColor,
        color,
        labelIcon: LabelIcon,
        labelInfo,
        labelText,
        colorForDarkMode,
        bgColorForDarkMode,
        onClickFolder,
        ...other
    } = props;

    const styleProps = {
        '--tree-view-color': theme.palette.mode !== 'dark' ? color : colorForDarkMode,
        '--tree-view-bg-color':
            theme.palette.mode !== 'dark' ? bgColor : bgColorForDarkMode,
    };

    return (
        <Drop itemId={props?.nodeId}>
            <StyledTreeItemRoot
                label={
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 0.5,
                            pr: 0,
                        }}>
                        <Box component={LabelIcon} onClick={onClickFolder} color="inherit" sx={{mr: 1}}/>
                            <Tooltip title={labelText.length > 45 ? labelText : ''}>
                                <Typography onClick={
                                    onClickFolder} variant="body2"
                                            sx={{fontWeight: 'inherit', textOverflow: "ellipsis", overflowX: "hidden", whiteSpace: "nowrap" }}>
                                    {labelText}
                                </Typography>
                            </Tooltip>
                        <Typography variant="caption" color="inherit">
                            {labelInfo}
                        </Typography>
                    </Box>
                }
                style={styleProps}
                {...other}
                ref={ref}
            />
        </Drop>
    );
});

export default StyledTreeItem;